
import {Component, OnInit, AfterViewInit, OnDestroy, Injector, ChangeDetectionStrategy} from '@angular/core';

import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';

import { CacheService } from '../../../../services/sys/cache.service';
import { StaticsService } from '../../../../services/sys/statics.service';
import { LocaleService } from '../../../../services/ui/locale.service';
import { PageTitleService } from '../../../../services/ui/page-title.service';

import { FieldMap } from '../../../interfaces/fieldMap.interface';
import {StringToStringMap} from "../../../interfaces/string-string-map.interface";
import {ApplicationService} from "../../../../services/domain/application.service";
import {Hit} from "../../../../services/model/hit";
import {Options} from "../../../interfaces/options.interface";
import {SubscriptionLike as ISubscription} from "rxjs";
import {QueryManagerService} from "../../../../services/domain/query-manager.service";
import {QueryCategory} from "../../../../services/model/queryCategory";
import {QueryValue} from "../../../../services/model/queryValue";
import {Subject} from "rxjs";
import {FilterManagerService} from "../../../../services/ui/filter-manager.service";
import {SettingsService} from "../../../../services/sys/settings.service";
import {Hits} from "../../../../services/model/hits";
import {CsvManagerService} from "../../../../services/domain/csv-manager.service";
import {ModalService} from "../../../../services/ui/modal.service";

declare var $: any;
declare global {
    interface Window {
        chrome: any;
        CSS: any;
        opr: any;
        opera: any;
    }
}

// @ts-ignore
@Component({
    selector: 'start',
    templateUrl: './start.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
    
export class StartComponent implements OnInit, AfterViewInit, OnDestroy {
    
    fieldMap: FieldMap;

    rolePrefix: string = "I am the&nbsp;";
    currRoute: string;
    localeHiddenVal: string;
    fieldLabels: StringToStringMap<string> = {};
    efastHits: Hits | null;
    isResultsShown: boolean = false;
    isDCGRowExisting: boolean = false;
    searchField: string = "";
    categoryType: string = "";
    fieldOptions: Options = {}
    hitsCnt: string = "0";
    notFoundMsg: string = "";
    isFilterShown: boolean = false;
    helpLink: string = "";
    AFSDDLink: string = "";
    Form5500SeriesDDLink: string = "";
    isMaxCntAbove: boolean = true;

    queryManagerChangeSubscription: ISubscription | null = null;
    eventsSubject: Subject<void> = new Subject<void>();

    constructor(
        private cacheService: CacheService,
        private router: Router,
        private applicationService: ApplicationService,
        private localeService: LocaleService,
        private staticsService: StaticsService,
        private queryManagerService: QueryManagerService,
        private filterManagerService: FilterManagerService,
        private settingsService: SettingsService,
        private csvManagerService: CsvManagerService,
        private modalService: ModalService) {
        this.queryManagerChangeSubscription = this.queryManagerService.queryManagerChangeSubject.subscribe(data => this.queryManagerChangeEvent(data));

    }

    ngOnInit() {

        this.fieldLabels['title'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONTitle');
        this.fieldLabels['note1'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONNote1');
        this.fieldLabels['note2'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONNote2');
        this.fieldLabels['note3'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONNote3');
        this.fieldLabels['noteDCG1'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONNoteDCG1');
        this.fieldLabels['noteDCG1A'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONNoteDCG1A');
        this.fieldLabels['noteDCG2'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONNoteDCG2');
        this.fieldLabels['noteDCG2A'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONNoteDCG2A');
        this.fieldLabels['noteDCG2Link'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONNoteDCG2Link');
        this.fieldLabels['noteDCG2B'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONNoteDCG2B');
        this.fieldLabels['noteDCG2C'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONNoteDCG2C');
        this.fieldLabels['noteDCG2D'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONNoteDCG2D');
        this.fieldLabels['search'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearch');
        this.fieldLabels['resultsCnt'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONResultsCnt');
        this.fieldLabels['resultsMaxMsg'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONResultsMax');
        this.fieldLabels['exportCsvBtn'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONExportCsvBtn');
        this.fieldLabels['resetFormBtn'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONResetFormBtn');
        this.fieldLabels['showFiltersBtn'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONShowFiltersBtn');
        this.fieldLabels['helpLink'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONHelpLink');
        this.helpLink = this.settingsService.getHelpLink();
        console.log("this.settingsService.getHelpLink() = " + this.settingsService.getHelpLink());


        this.fieldLabels['DDNote1'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONDataDictionary1');
        this.fieldLabels['DDNote2'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONDataDictionary2');
        this.fieldLabels['DDNote3'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONDataDictionary3');
        this.fieldLabels['AFSDDLink'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONAFSCSVDataDictionaryLink');
        this.AFSDDLink = this.settingsService.getAFSDDLink();
        this.fieldLabels['Form5500SeriesDDLink'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONForm5500SeriesDataDictionaryLink');
        this.Form5500SeriesDDLink = this.settingsService.getForm5500SeriesDDLink();

        this.categoryType = this.staticsService.getCategoryType().PLAN_NAME;

        this.fieldLabels['hideFiltersBtn'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONHideFiltersBtn');

        this.notFoundMsg = this.cacheService.getLabelFromResource("messages:msg.noSearchRecordsFound");

        

        const dropdowns = this.cacheService.getDropdowns();

        this.fieldOptions['categoryType'] = dropdowns['OptionText.AfsSearchChoices'].choices;

        this.onCategoryTypeChanged();
        this.modalService.showProcessingModal();
    }

	ngAfterViewInit() {

        if ($('#localeHidden').length > 0) {
            this.localeHiddenVal = $('#localeHidden').val();
        } else {
            this.localeHiddenVal = '';
        }
        
        this.modalService.hideProcessingModal()

    }

    initializeView() {
        this.localeService.getLanguage();

        
    }

    private queryManagerChangeEvent(data) {
        this.modalService.showProcessingModal();
        this.search();
    }

    public go() {
        if (this.searchField.length> 0) {
            this.modalService.showProcessingModal();
            this.search();
            //put focus on result tag for 508
           setTimeout(() => $("#resultsCntID").focus());
        }
    }

    async search() {

        let queryCategory: QueryCategory = new QueryCategory();
        let queryValues: QueryValue[] = new Array();

        queryCategory.isFilter = false;
        queryCategory.type = this.categoryType;
        queryCategory.queryValues = queryValues;

        this.queryManagerService.evaluateSearch(queryCategory, this.searchField);

        await this.applicationService.search();

        if (this.applicationService.getAfsForm().hits != undefined) {
            if (this.applicationService.getAfsForm().hits.hit.length > 0) {
                this.efastHits = this.applicationService.getAfsForm().hits;
                if (this.applicationService.getAfsForm().hits.found >= Number(this.settingsService.getRecordsMaxTotal())) {
                    this.isMaxCntAbove = true;
                    this.hitsCnt = this.settingsService.getRecordsMaxTotal();
                }
                else {
                    this.hitsCnt = this.applicationService.getAfsForm().hits.found.toString();
                    this.isMaxCntAbove = false;
                }
                this.isResultsShown = true;
                
                this.isDCGRowExisting = this.applicationService.isDCGRowExisting();
                
            } else {
                this.efastHits = null;
                this.isResultsShown = false;
                this.isDCGRowExisting = false;
                this.isMaxCntAbove = false;
                if (this.queryManagerService.getQueryCategories().length > 0) {
                    this.hitsCnt = this.notFoundMsg;
                }
                else {
                    this.hitsCnt = "0";
                }

            }
        }
        this.modalService.hideProcessingModal()
        this.eventsSubject.next();
        this.searchField = "";
    }

    onCategoryTypeChanged() : void {
       // nothing to do for now
    }

    async toggleFilter() {
        //VWM moving search to toggle filter
        this.modalService.showProcessingModal();
        await this.search();
        
        if (this.applicationService.getAfsForm() != undefined) {
            if (!this.isFilterShown) {
                this.isFilterShown = true;
            } else {
                this.isFilterShown = false;
            }
            this.eventsSubject.next();
        }
        else {
            this.modalService.showErrorModal();
        }
    }

    async exportCsv() {
        if (this.applicationService.getAfsForm() != undefined) {
            if (this.applicationService.getAfsForm().hits.hit.length != 0) {
                this.modalService.showProcessingModal();
                await this.applicationService.retrieveCsv();
                this.csvManagerService.generate(this.applicationService.getCsvForm());
                this.modalService.hideProcessingModal();
            } else {
                this.modalService.showNotFoundModal();
            }
        }
        else {
            this.modalService.showErrorModal();
        }
    }

    resetForm() {
        this.efastHits = null;
        this.isResultsShown = false;
        this.isDCGRowExisting = false;
        this.hitsCnt = "0";
        this.queryManagerService.reset();
        this.filterManagerService.reset();
        this.applicationService.resetTablePositionStatus();
        this.categoryType = this.staticsService.getCategoryType().PLAN_NAME;
        this.isFilterShown = false;
    }

    next() {
        this.router.navigate(['ENTRY']);
    }


    ngOnDestroy() {
    }
    
    showHelp(file : string) : void {
       //this.helpService.startHelpSidenav(file);
    }
}
